import { MouseEvent } from 'react';

import {
  LAYOUT_MAIN_ID,
  LAYOUT_NAVIGATION_ID,
  LAYOUT_SEARCH_ID,
  LAYOUT_NOTIFICATIONS_ID,
} from './layout.constants';
import * as Styled from './layout-skip-links.style';

const LayoutSkipLinks = () => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    el?.focus();
  };

  return (
    <>
      <Styled.SkipLink
        href={`#${LAYOUT_MAIN_ID}`}
        onClick={e => handleClick(e, LAYOUT_MAIN_ID)}
      >
        <span>Skip to main content</span>
      </Styled.SkipLink>
      <Styled.SkipLink
        href={`#${LAYOUT_NAVIGATION_ID}`}
        onClick={e => handleClick(e, LAYOUT_NAVIGATION_ID)}
      >
        <span>Skip to navigation</span>
      </Styled.SkipLink>
      <Styled.SkipLink
        href={`#${LAYOUT_SEARCH_ID}`}
        onClick={e => handleClick(e, LAYOUT_SEARCH_ID)}
      >
        <span>Skip to search</span>
      </Styled.SkipLink>
      <Styled.SkipLink
        href={`#${LAYOUT_NOTIFICATIONS_ID}`}
        onClick={e => handleClick(e, LAYOUT_NOTIFICATIONS_ID)}
      >
        <span>Skip to notifications</span>
      </Styled.SkipLink>
    </>
  );
};

export default LayoutSkipLinks;
